import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import CommonItem from '../CommonItem/CommonItem';
import { useConfig } from '../../../context';
import { useStartCheckIn, StartCheckInButton } from '@features/start-check-in';
const OrderCardControls = props => {
    const { checkinRules, isCheckinAvailable } = useStartCheckIn();
    const { global: { companyInfo: { iataCode } } } = useConfig();
    const { t } = useTranslation('OrderCard');
    const theme = useTheme('OrderCard').OrderCardControls;
    const isVisible = iataCode === 'N4' ? isCheckinAvailable : checkinRules;
    if (!isVisible) {
        return null;
    }
    return (React.createElement(CommonItem, { className: theme.root, icon: 'Document/Boarding pass', text: t('Online check-in started'), buttons: React.createElement(StartCheckInButton, { buttonClassName: cn(theme.button, theme.button_checkin) }) }));
};
export default OrderCardControls;
